module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.db7d11c1.jpeg";